import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable max-classes-per-file */
// export class MultipleFieldsError extends Error {}

export var CircularReferenceError = /*#__PURE__*/function (_Error) {
  _inherits(CircularReferenceError, _Error);
  var _super = _createSuper(CircularReferenceError);
  function CircularReferenceError() {
    _classCallCheck(this, CircularReferenceError);
    return _super.call(this, 'CircularError: обнаружено замыкание узлов на себе');
  }
  return _createClass(CircularReferenceError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var NotImplementedError = /*#__PURE__*/function (_Error2) {
  _inherits(NotImplementedError, _Error2);
  var _super2 = _createSuper(NotImplementedError);
  function NotImplementedError() {
    _classCallCheck(this, NotImplementedError);
    return _super2.apply(this, arguments);
  }
  return _createClass(NotImplementedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var EntangledChildrenException = /*#__PURE__*/function (_Error3) {
  _inherits(EntangledChildrenException, _Error3);
  var _super3 = _createSuper(EntangledChildrenException);
  function EntangledChildrenException() {
    _classCallCheck(this, EntangledChildrenException);
    return _super3.call(this, 'EntangledChildrenException: часть дочерних узлов находятся за пределами выбранных');
  }
  return _createClass(EntangledChildrenException);
}( /*#__PURE__*/_wrapNativeSuper(Error));